import { getIntentKey } from '../routing/getIntentKey';
export const isIntent = intent => {
  const intentKey = getIntentKey();
  const intentKeysToCheck = Array.isArray(intent) ? intent : [intent];
  const intentCheck = intentKey && intentKeysToCheck.includes(intentKey);
  return intentCheck;
};